import {
  Button,
  Card,
  Form, Input, Mentions,
  Modal,
  Switch,
  theme,
  Typography,
} from "antd";
import {
  CloseOutlined,
  DownloadOutlined,
  LinkOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import React, {useCallback, useEffect, useState} from "react";
import {
  createChatInstance,
  deleteChatInstance,
  getChatInstance,
  updateChatInstance,
} from "../../services/chatIntegration";
import { toast } from 'sonner'

const mentions = [
  {
    label: "atendente",
    value: "atendente",
  },
  {
    label: "protocolo",
    value: "protocolo",
  }
]

export function ChatIntegration({icon, label, description, assistantID, chatbotID}) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [form] = Form.useForm();

  const {
    token: {colorPrimary},
  } = theme.useToken();

  useEffect(() => {
    if (!assistantID && !chatbotID) {
      setLoading(false);
      return
    }
    setLoading(true)
    getChatInstance({assistantID, chatbotID}).then(({data}) => {
      if (data.length === 0)
        return

      setData(data[0])
    }).catch((error) => {
      console.log(error)
      toast.error("Erro ao buscar integração de chat.");
    }).finally(() => {
      setLoading(false)
    });
  }, [assistantID, chatbotID]);

  const install = useCallback(() => {
    setButtonLoading(true)
    const createRequest = {
      ...(assistantID && { assistantID }),
      ...(chatbotID && { chatbotID }),
    };

    createChatInstance(createRequest).then(({data}) => {
      setData(data);
    }).catch((error) => {
      toast.error("Erro ao instalar integração de chat.");
    }).finally(() => {
      setButtonLoading(false);
    });
  }, [assistantID, chatbotID]);

  const uninstall = useCallback(() => {
    setButtonLoading(true);
    deleteChatInstance(data.id).then(() => {
      setData(undefined);
    }).catch((error) => {
      toast.error("Erro ao remover integração de chat.");
    }).finally(() => {
      setButtonLoading(false)
    });
  }, [data]);

  const update = useCallback(async (newData) => {
    setButtonLoading(true);
    await updateChatInstance(data.id, {...data, ...newData}).then(({data: updatedData}) => {
      setData({...updatedData});
      setConfigOpen(false);
      toast.success("Atualizado com sucesso!");
    }).catch((error) => {
      toast.error("Erro ao atualizar.");
    }).finally(() => {
      setButtonLoading(false);
    });
  }, [data]);

  const save = useCallback(async (values) => {
    await form.validateFields().then(() => {
      update(values);
    }).catch((err) => {
    })

  }, [form, update]);

  const handleConfigOpen = () => {
    form.setFieldsValue(data);
    setConfigOpen(true);
  }

  const handleConfigClose = () => {
    form.resetFields()
    setConfigOpen(false)
  }

  return (
    <>
      <Modal title="Configurar Chat"
             open={configOpen}
             cancelText={'Cancelar'}
             confirmLoading={buttonLoading}
             okText={'Salvar'}
             onOk={form.submit}
             onCancel={handleConfigClose}>
        <br/>
        <Form layout={'vertical'} form={form} onFinish={save}>
          <Form.Item
            label={'Enviar nome do atendente'}
            name={'sendName'}
            valuePropName={"checked"}
            help={'Envia o nome do atendente que realizou o atendimento'}
            initialValue={false}>
            <Switch defaultValue={false}/>
          </Form.Item>
          <Form.Item
            label={'Mensagem a ser enviado ao iniciar atendimento'}
            name={'notifyStartMessage'}
            initialValue={''}
            help={'Use $atendente e $protocolo para substituir o nome do atendente e protocolo.'}>
            <Mentions
              prefix="$"
              split=""
              options={mentions}
              placeholder={'$atendente assumiu o seu atendimento, seu protocolo é $protocolo'}/>
          </Form.Item>
          <Form.Item
            label={'Mensagem a ser enviada ao encerrar atendimento'}
            name={'notifyEndMessage'}
            initialValue={""}
            help={'Use $atendente e $protocolo para substituir o nome do atendente e protocolo.'}>
            <Mentions
              prefix="$"
              split=""
              options={mentions}
              placeholder={'$atendente encerrou o seu atendimento, seu protocolo é $protocolo'}/>
          </Form.Item>
        </Form>
      </Modal>
      <Card
        loading={loading}
        title={<Typography.Title level={5} ellipsis={{tooltip: label}}>{icon} {label}</Typography.Title>}
        actions={data ? [<SettingOutlined onClick={handleConfigOpen}/>,
          <a href={`/chat/${assistantID ? 'assistants' : 'chatbots'}/${assistantID ?? chatbotID}`} target={'_blank'} rel="noopener noreferrer">
            <LinkOutlined/>
          </a>] : undefined}
        extra={<Button type={data ? 'default' : 'primary'}
                       loading={loading || buttonLoading}
                       danger={!!data}
                       onClick={() => data ? uninstall() : install()}
                       icon={data ? <CloseOutlined/> : <DownloadOutlined/>}
        >{loading ? undefined : data ? 'Remover' : 'Instalar'}</Button>}>
        {description}
      </Card>
    </>
  )
}
